<template>
	<div class="icon">
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve">
			<g><path d="M10,173.3h980v109.8H10V173.3z M10,553.6V446.4h980v107.2H10z M10,826.7V716.9h980v109.8H10z"/></g>
		</svg>
	</div>	
</template>

<script>
	export default {
		name: "MenuIcon"
	}
</script>

<style scoped>

.icon {
	fill: #fff;
	display: block;
	margin: 0;
}

</style>




// WEBPACK FOOTER //
// src/icons/MenuIcon.vue